import { BellOutlined } from "@ant-design/icons";
import { Button, Flex, Result, Typography } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";

const UnknownOrganization: React.FC = () => {
  return (
    <div className="message-section">
      <Flex align="center" justify="center" vertical gap={8}>
        <Result
          status="warning"
          title="There seems to be an error with the link, please check and retry."
           style={{maxWidth: 800}}
          // subTitle="QualifyMe is an AI based hiring assistant. If you would like to use it
          // for your company,"
          // extra={[
          //   <NavLink to={"https://qualifyme.ai"} replace>
          //     {" "}
          //     Please click
          //   </NavLink>
          // ]}
        />
      </Flex>
    </div>
  );
};

export default UnknownOrganization;
